import {Button as MuiButton, Theme, withStyles} from "@material-ui/core";



const Button = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 0,
    backgroundColor: theme.palette.common.white,
    fontWeight:'bold',
    width: '100%',
    '&:disabled':{
      backgroundColor: theme.palette.grey['300'],
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
}))(MuiButton);

export default Button;
